"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdultServiceApplicableMeasuresItem = void 0;
const Field_type_1 = require("../../../types/Field.type");
const MonitoringMeasures_1 = require("../../enm/MonitoringMeasures");
exports.AdultServiceApplicableMeasuresItem = {
    priority: 1,
    label: 'fields.enm.monitoring_measures.label',
    fallbackLabel: 'Please confirm the applicable measures implemented on the organizational level of your company to be able to efficiently monitor and respond to any legal  or regulatory changes that could impact merchants active in this sector:',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['mor_group_answers.has_adult_service_segment', 'contract_onboarding_type'],
    type: Field_type_1.FieldType.Enum,
    options: MonitoringMeasures_1.MonitoringMeasuresRef.options,
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return payload.mor_group_answers?.has_adult_service_segment === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return payload.mor_group_answers?.has_adult_service_segment === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
